import BaseStrapiCollection from "../base-strapi-collection/base-strapi-collection";
import qs from "qs";
export default class CreditLedgerEntry extends BaseStrapiCollection {
    static kind = "collectionType";
    static singularName = "credit-ledger-entry";
    static pluralName = "credit-ledger-entries";
    static displayName = "Credit Ledger Entry";
    constructor() { super(`${CreditLedgerEntry.kind}`, `${CreditLedgerEntry.singularName}`, `${CreditLedgerEntry.pluralName}`); }
    async getAll(query = {}) { return await this.fetch(qs.stringify({...query}, {encodeValuesOnly: true})); }
    async getById(id, query = {}) { return await this.find(id, {populate: "*", ...query}); }
}
